<h2 mat-dialog-title>Failed Payment</h2>
<mat-dialog-content>
  <p>There has been a failed payment on your account.</p>
  <p>
    Payments can fail for several reasons, such as an expired credit card or insufficient funds in your account. Update
    your payment information and retry the payment to avoid any disruption in service. If you have any questions, you
    can contact us at
    <span *ngIf="supportNumber$ | async as supportNumber">
      <a href="tel:{{ supportNumber }}">{{ supportNumber }}</a>
      or
    </span>
    <a href="mailto:partnersuccess@vendasta.com" target="_blank">partnersuccess&#64;vendasta.com</a>
    .
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button [matTooltip]="'Close'" mat-button (click)="closeDialog()">Close</button>
  <button *ngIf="userCanAccessBilling$ | async" (click)="closeDialogAndGoToBilling()" mat-raised-button color="primary">
    View Failed Payments
  </button>
</mat-dialog-actions>
